import { RaceSummaryRow } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/RaceSummaryNew.style';
import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const ScrollRowWrapper = withConfig(theme => styled(RaceSummaryRow, { label: 'ScrollRowWrapper' })<{isNonRunner: boolean}>`
    display: flex;
    flex-wrap: nowrap;
    min-height: 72px;
    border-bottom: 0;
    opacity: ${({ isNonRunner }): string => isNonRunner === true ? '0.4' : '1'};
    @media ${theme.star.mediaQuery.tablet} {
        min-height: 64px;
    }
`);
